<template>
  <iModal
    v-model="visible"
    title="发布供需"
    :z-index="1010"
    @on-cancel="cancel"
    class-name="supply-modal"
    width="600"
    :footer-hide="true"
  >
    <div class="supply-modal">
      <Form ref="formInline" style="width:500px;margin:50px auto;" :model="formInline" :label-width="100" :rules="ruleInline">
        <FormItem label="供需类型：">
          <Select v-model="formInline.typeId">
            <Option v-for="item in typeList" :value="item.id" :key="item.name">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="info" label="我需要：">
          <Input type="text" v-model="formInline.info" placeholder="如 体育用品类展会推荐" />
        </FormItem>
        <FormItem prop="linkman" label="联系人：">
          <Input type="text" v-model="formInline.linkman" placeholder="请输入您的称谓" />
        </FormItem>
        <FormItem prop="phone" label="手机号：">
          <Input type="text" v-model="formInline.phone" placeholder="信息保护中，仅官方可见" />
        </FormItem>
        <div style="text-align:center;padding-top:20px;">
          <Button style="width:100px;height:36px;" :loading="loading" type="error" @click="handleSubmit('formInline')">发布需求</Button>
        </div>
      </Form>
    </div>
  </iModal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "supply-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    infoData: {
      type: Object,
      default: () => {}
    },
    infoType: {
      type: String,
      default: ""
    }
  },
  data() {
    const that = this;
    const typeReg = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        callback('请选择类型');
      } else {
        callback();
      }
    };
    const phoneReg = (rule, value, callback) => {
      if (!value) {
        callback('请输入手机号码');
      } else if (/^[1][0-9]{10}$/.test(value)) {
        callback();
      } else {
        callback('请输入正确的手机号码');
      }
    };
    return {
      typeList: [],
      visible: false,
      loading: false,
      formInline: {
        typeId: "",
        info: "",
        linkman: "",
        phone: "",
      },
      ruleInline: {
        info: [{ required: true, message: "请输入供需内容", trigger: "blur" }],
        linkman: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        type: [{ required: true, validator: typeReg, trigger: "change" }],
        phone: [{ required: true, validator: phoneReg, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibition: "loginModule/getExhibition"
    }),
  },
  watch: {
    show(val, oldVal) {
      this.visible = val;
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    ...mapActions({
      getRelease: "hall/getRelease",
      sendRelease: "hall/sendRelease"
    }),
    async init() {
      let typeList = await this.getRelease(this.exhibition.id);
      this.typeList = typeList;
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      
      if (!this.formInline.typeId) {
        this.$Message.warning("请选择供需类型");
        return;
      }
      this.loading = true;
      var req = {
        AgentId: this.exhibition.agentId,
        ExhibitionId: this.exhibition.id,
        TypeId: this.formInline.typeId,
        FromType: 1, // 《0：企业，1：用户》(小程序端只有用户)
        FromId: this.user.userId,
        Information: this.formInline.info,
        SourceType: this.infoType,
      };
      if (this.infoType === "展商") {
        req.SourceId = this.infoData.compId;
        req.SourceName = this.infoData.name;
      } else if (this.infoType === "展品") {
        req.SourceId = this.infoData.id;
        req.SourceName = this.infoData.name;
      } else if (this.infoType === "供需") {
        req.SourceId = this.infoData.id;
        req.SourceName = this.infoData.information;
      }
      var result = await this.sendRelease(req);
      if (result.successed) {
        this.loading = false;
        this.$Message.success("发布成功！");
        this.cancel();
      } else {
        this.loading = false;
        this.$Message.error("发布失败，请重试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        typeId: "",
        info: "",
        linkman: "",
        phone: "",
      }
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.supply-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal{
    top: 0;
  }
  .ivu-modal-body {
    padding: 0;
  }
}
</style>